
import React from 'react';
import { CommonModule, UCAModule } from "uca-react-containers-library";

const ResetPasswordComponent = () => {
    return (
        <CommonModule.ViewportProvider>
            <UCAModule.ResetPassword />
        </CommonModule.ViewportProvider>
    );
};

export default ResetPasswordComponent;
